import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import ApiDocsPanel from '../utilities/ApiDocsPanel';
import '../../styles/_userMessageForm.scss';
import { getWhatsAppApiExamples } from '../utilities/utilities/WhatsAppApiExamples';

const UserMessageForm = ({ phoneNumber, boundedPhone, onSubmit, onBack, onSkip, isLoading }) => {
  const [formData, setFormData] = useState({
    to: boundedPhone,
    from: phoneNumber,
    message: '',
  });

  const userMessageCodeExamples = getWhatsAppApiExamples(
    'text',
    formData.to,
    'your_whatsapp_phone_id'
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="user-message-form">
      <h3 className="form-title">Start a user-initiated conversation</h3>
      <p className="form-description">
        When customers reach out to you first, outside an ongoing conversation, you can reply
        without using templates. A user-initiated conversation remains open for 24 hours after the
        customer's first message.
      </p>
      <p className="form-description">
        To test this, reply to the WhatsApp notification on your device to open a 24-hour
        conversation window.
      </p>

      <Row>
        <Col md={4}>
          <div className="user-message-info">
            <p>
              Message from you:
              <br />
              From: whatsapp: {boundedPhone}
              <br />
              Body: Confirm your order
            </p>
          </div>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>To</Form.Label>
              <Form.Control
                type="text"
                name="to"
                value={formData.to}
                onChange={handleChange}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>From</Form.Label>
              <Form.Control
                type="text"
                name="from"
                value={formData.from}
                onChange={handleChange}
                disabled
                className="disabled-input"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Body</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message here"
              />
            </Form.Group>

            <Form.Group className="mb-4 d-flex justify-content-between">
              <Button variant="ghost" className="back-btn" onClick={onBack} disabled={isLoading}>
                Back
              </Button>
              <div className="d-flex gap-2">
                <Button variant="ghost" onClick={onSkip} disabled={isLoading}>
                  Skip this step
                </Button>
                <Button variant="primary" type="submit" className="send-reply-btn" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Sending...
                    </>
                  ) : (
                    'Send your reply'
                  )}
                </Button>
              </div>
            </Form.Group>
          </Form>
        </Col>
        <Col md={8}>
          <ApiDocsPanel codeExamples={userMessageCodeExamples} />
        </Col>
      </Row>
    </div>
  );
};

UserMessageForm.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  boundedPhone: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

UserMessageForm.defaultProps = {
  isLoading: false,
};

export default UserMessageForm;
